import scaffold from '@shared/msp/interfaces.js';
import constants from '@shared/msp/constants.js';
import constructors from '@shared/msp/constructors.js';
import api from '@shared/msp/api.js';
import storage from '@shared/msp/storage.js';
import callbacks from '@shared/msp/callbacks.js';
import url from '@shared/msp/url.js';
import color from '@shared/msp/colors.tinycolor.js';
import funzioni from '@shared/msp/funzioni.js';

const MSP = Object.assign(
  {
    interfaces: scaffold,
    api: api,
    color: color,
  },
  constructors,
  constants,
  storage,
  callbacks,
  url,
  funzioni,
);

export default MSP;
